import React, {  useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box'; 
import CircularProgress from '@mui/material/CircularProgress'; 
import Container from '@mui/material/Container';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import TextField from '@mui/material/TextField'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types';
import TableSortingArticle from 'pages/purchaseDelivery/editOrNewPurchaseDelivery/SortingTablesPurchaseDeliveryArticles'; 

const initialFiltersArticle= {
  "idFrom":"",
  "idTo":"",
  "codeFrom":"",
  "codeTo":"",
  "codeLerFrom":"",
  "codeLerTo":"",
  "nameesFrom":"",
  "nameesTo":"",
  "nameenFrom":"",
  "nameenTo":""
};
 
const initialStateArticle = [{
  "article_id":0,
  "article_code": "",
  "article_codeler": "",
  "article_namees": "",
  "article_nameen": "",
  "estimatedprice": 0, 
  "tax":0,
  "taxincluded":false,
  "ticketweight":true,
}];
        

const PurchaseDeliverySearchArticles = ({ showModalSearchArticles, setShowModalSearchArticles,formPurchaseDelivery,setFormPurchaseDelivery}) => {
  const {t,i18n} = useTranslation(['listDataPurchases']);
  const token = useSelector((state) => state.loginUser.token);  
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesize);
  const [dataArticle, setDataArticle] = useState(initialStateArticle);
  const [isLoadingErrorArticle, setIsLoadingErrorArticle] = useState(false);
  const [isLoadingArticle, setIsLoadingArticle] = useState(false);  
  const [inputTextArticle, setInputTextArticle] = useState("");
  const [applyFiltersArticle, setApplyFiltersArticle]= useState(initialFiltersArticle);
  const [filtersArticle, setFiltersArticle]= useState(initialFiltersArticle);
  const [openEditFilterArticle,setOpenEditFilterArticle]= useState(false);
  const [errorsFiltersArticle, setErrorsFiltersArticle] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegArticle,setNumTotRegArticle]= useState(0);
  const [activeOffsetArticle, setActiveOffsetArticle]= useState(false);
  const [currencyOffsetArticle, setCurrencyOffsetArticle] = useState(0);
  const [rangeOffsetArticle, setRangeOffsetArticle] = useState([{}]); 
  const dispatch = useDispatch(); 
   
  const handleCloseDataEditArticle = () => {
    setDataArticle(initialStateArticle);
    setIsLoadingErrorArticle(false);
    dispatch(setLoading(false));
    setInputTextArticle("");
    setApplyFiltersArticle(initialFiltersArticle);
    setFiltersArticle(initialFiltersArticle);
    setOpenEditFilterArticle(false);
    setErrorsFiltersArticle({});
    setNumTotRegFilter(0);
    setNumTotRegArticle(0);
    setActiveOffsetArticle(false);
    setCurrencyOffsetArticle(0);
    setRangeOffsetArticle([{}]); 
    setShowModalSearchArticles(false)
	};

  const toggleDrawerSearchArticles  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditArticle();
    }
  };

  let inputHandlerArticle = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextArticle(lowerCase);
  };

  const openEditFiltersArticle = () => {
    setFiltersArticle(applyFiltersArticle);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const toggleDrawerFilterEditArticle = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditArticle();
    }
  };

  const handleCancelFiltersArticle = () => {
    setErrorsFiltersArticle({});
    setFiltersArticle(initialFiltersArticle);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const handleChangeFilterEditArticle = (e) => {
    const { name, value } = e.target;
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      [name]: value
    }));
  };

  const handleBlurFilterEditArticle = (e) => {
    setErrorsFiltersArticle(validateFormFilterArticle());
    handleChangeFilterEditArticle(e);
  };
 
  const handleSubmitFilterEditArticle = () => {
    setErrorsFiltersArticle(validateFormFilterArticle());
    if (Object.keys(errorsFiltersArticle).length === 0) {
      setApplyFiltersArticle(filtersArticle);
      setFiltersArticle(initialFiltersArticle);
      setErrorsFiltersArticle({});
      setOpenEditFilterArticle(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeleteFiltersArticle = () => {
    setErrorsFiltersArticle({});
    setFiltersArticle(initialFiltersArticle);
    setApplyFiltersArticle(initialFiltersArticle);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const validateFormFilterArticle = () => {
    let errorsFiltersArticle = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (filtersArticle.idFrom!=="" & !regexNumber.test(filtersArticle.idFrom)) {
      errorsFiltersArticle.idFrom = 'Text_TextNoNumber';
    }
    if (filtersArticle.idTo!=="" & !regexNumber.test(filtersArticle.idTo)) {
      errorsFiltersArticle.idTo = 'Text_TextNoNumber';
    }
    if (filtersArticle.idFrom!=="" & !errorsFiltersArticle.idFrom!==undefined){
      if (filtersArticle.idTo!=="" & !errorsFiltersArticle.idTo!==undefined){
        if (parseInt(filtersArticle.idTo)<parseInt(filtersArticle.idFrom)){
          errorsFiltersArticle.idTo = 'Text_TextGreater_Id';
        }
      }
    }
    if (regexInvalidCharacters.test(filtersArticle.nameesFrom)) {
      errorsFiltersArticle.nameesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameesTo)) {
      errorsFiltersArticle.nameesTo = 'Text_TextNoValid';
    } 
     if (regexInvalidCharacters.test(filtersArticle.nameesFrom)) {
      errorsFiltersArticle.nameesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameesTo)) {
      errorsFiltersArticle.nameesTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameenFrom)) {
      errorsFiltersArticle.nameenFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.nameenTo)) {
      errorsFiltersArticle.nameenTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.codeLerFrom)) {
      errorsFiltersArticle.codeLerFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.codeLerTo)) {
      errorsFiltersArticle.codeLerTo = 'Text_TextNoValid';
    } 
    if (filtersArticle.nameesTo!=="" & filtersArticle.nameesTo<filtersArticle.nameesFrom){
      errorsFiltersArticle.nameesTo = 'Text_TextGreater_Namees';
    }
    if (filtersArticle.nameenTo!=="" & filtersArticle.nameenTo<filtersArticle.nameenFrom){
      errorsFiltersArticle.nameenTo = 'Text_TextGreater_Nameen';
    }
    if (filtersArticle.codeTo!=="" & filtersArticle.codeTo<filtersArticle.codeFrom){
      errorsFiltersArticle.codeTo = 'Text_TextGreater_Article';
    }
    if (filtersArticle.codeLerTo!=="" & filtersArticle.codeLerTo<filtersArticle.codeLerFrom){
      errorsFiltersArticle.codeLerTo = 'Text_TextGreater_ArticleLER';
    }
    return errorsFiltersArticle;
  }  

  const filteredDataArticle = dataArticle.filter((el) => {
    if (inputTextArticle === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.article_code || '') +
         String(el.article_codeler || '') +
        String(el.article_namees || '') +
        String(el.article_nameen || '');
      let result = dataTranslate.toLowerCase().includes(inputTextArticle.toLowerCase());
      return result;
    }
  })

  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegArticle = async () => {
      dispatch(setLoading(true));
      try { 
        const getData = await helpHttp().get(ENDPOINT, `purchasedelivery/getinformationtablearticles`, token);
        if (getData.err) {
          setDataArticle(initialStateArticle);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegArticle(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchnumTotRegFilter = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post(ENDPOINT, `purchasedelivery/getcountfilterarticles`, token, applyFiltersArticle);
        if (getData.err || getData.message === "Load failed") {
          setDataArticle(initialStateArticle);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchDataArticle = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT,`purchasedelivery/getarticles`,token,currencyOffsetArticle,LIMITPAGESIZE,applyFiltersArticle);
        if (getData.err || getData.message === "Load failed") {
          setDataArticle(initialStateArticle);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataArticle(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    
    if (showModalSearchArticles){
      fetchnumTotRegArticle();
      fetchnumTotRegFilter();
      fetchDataArticle(); 
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,LIMITPAGESIZE,applyFiltersArticle,currencyOffsetArticle,setIsLoadingArticle,showModalSearchArticles]);

  return(
    <>
      {showModalSearchArticles && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchArticles(false)}
            onOpen={toggleDrawerSearchArticles(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff', width: '1150px'}}>
                <br/>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    {isLoadingErrorArticle?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingArticle?<CircularProgress color={"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_ARTICLEs_Search')}
                  </h1>
                  <div>
                    <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={handleCloseDataEditArticle}>{t('Button_Back')}</button><> </>
                  </div> 
                </div>  
                <br/>  
                <div className="formdi-pending-search">
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    value={inputTextArticle}
                    inputProps={{ style: {fontSize: '18px'} }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                    placeholder={t('Text_ARTICLE_Search')} 
                    onChange={inputHandlerArticle}
                    fullWidth
                    label={t('Text_ARTICLE_Search')}>
                  </TextField>
                </div>
                <br/>
                <div id="myNewDIV" className="formdi-pending-filters">
                  <h1 className="formdi-pending-filter-title">{t('Text_Filter')}</h1> 
                    <div className="formdi-pending-filters-row">
                      <button type="button" className={`formdi-pending-chip ${applyFiltersArticle.codeFrom !== "" || applyFiltersArticle.codeTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                        <span className={`formdi-pending-dot ${ applyFiltersArticle.codeFrom !== "" || applyFiltersArticle.codeTo !== ""? "formdi-pending-dot--on": ""}`}/>
                          {t('Text_ARTICLE_Code').toUpperCase()}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${applyFiltersArticle.codeLerFrom !== "" || applyFiltersArticle.codeLerTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                        <span className={`formdi-pending-dot ${ applyFiltersArticle.codeLerFrom !== "" || applyFiltersArticle.codeLerTo !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t('Text_ARTICLE_CodeLER').toUpperCase()}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${(applyFiltersArticle.nameesFrom!=="" || applyFiltersArticle.nameesTo!=="" || applyFiltersArticle.nameenFrom!=="" || applyFiltersArticle.nameenTo!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersArticle} >
                        <span className={`formdi-pending-dot ${(applyFiltersArticle.nameesFrom!=="" || applyFiltersArticle.nameesTo!=="" || applyFiltersArticle.nameenFrom!=="" || applyFiltersArticle.nameenTo!=="")? "formdi-pending-dot--on": ""}`}/>
                        {t('Text_ARTICLE_Name').toUpperCase()}
                      </button> 
                  </div>
                </div> 
                <br/> 
                {!isLoadingArticle ?
                  <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                        <TableSortingArticle
                          dataArticle={filteredDataArticle}
                          numTotRegFilter={ numTotRegFilter}
                          titleTable={t('Text_ARTICLE_Table')}
                          numTotRegArticle={numTotRegArticle}
                          activeOffsetArticle={activeOffsetArticle}
                          rangeOffsetArticle={rangeOffsetArticle}
                          currencyOffsetArticle={currencyOffsetArticle}
                          setCurrencyOffsetArticle={setCurrencyOffsetArticle} 
                          formPurchaseDelivery={formPurchaseDelivery}                                  
                          setFormPurchaseDelivery={setFormPurchaseDelivery}
                          handleCloseDataEditArticle={handleCloseDataEditArticle}
                        >
                        </TableSortingArticle>
                      </div>             
                    </div>
                    {openEditFilterArticle &&
                      <div>
                      <SwipeableDrawer
                        anchor='right'
                        open={true}
                        onClose={toggleDrawerFilterEditArticle(false)}
                        onOpen={toggleDrawerFilterEditArticle(true)}>
                        <Container >
                          <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '1100' }}>
                            <br/>
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <form className="newfilterformstore" onSubmit={handleCancelFiltersArticle}>  
                                <div className="form-floating mb-3 px-4 primary">
                                    <div className="form-group">
                                    <TextField
                                      id="codeFrom" 
                                      name="codeFrom"
                                      value={filtersArticle.codeFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.codeFrom!=null?t(errorsFiltersArticle.codeFrom):t('Text_Filter_CodeArticle_From')}
                                      placeholder={t('PlaceHolder_Filter_CodeArticle_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/> 
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <TextField
                                      id="codeTo" 
                                      name="codeTo"
                                      value={filtersArticle.codeTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.codeTo!=null?t(errorsFiltersArticle.codeTo):t('Text_Filter_CodeArticle_To')}
                                      placeholder={t('PlaceHolder_Filter_CodeArticle_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                   <div className="form-group">
                                    <TextField
                                      id="codeLerFrom" 
                                      name="codeLerFrom"
                                      value={filtersArticle.codeLerFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.codeLerFrom!=null?t(errorsFiltersArticle.codeLerFrom):t('Text_Filter_CodeLERArticle_From')}
                                      placeholder={t('PlaceHolder_Filter_CodeLERArticle_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/> 
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <TextField
                                      id="codeLerTo" 
                                      name="codeLerTo"
                                      value={filtersArticle.codeLerTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 10 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.codeLerTo!=null?t(errorsFiltersArticle.codeLerTo):t('Text_Filter_CodeLERArticle_To')}
                                      placeholder={t('PlaceHolder_Filter_CodeALERrticle_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="nameesFrom" 
                                      name="nameesFrom"
                                      value={filtersArticle.nameesFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.nameesFrom!=null?t(errorsFiltersArticle.nameesFrom):t('Text_Filter_NameEs_From')}
                                      placeholder={t('PlaceHolder_Filter_NameEs_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="nameesTo" 
                                      name="nameesTo"
                                      value={filtersArticle.nameesTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersArticle.nameesTo!=null?t(errorsFiltersArticle.nameesTo):t('Text_Filter_NameEs_To')}
                                      placeholder={t('PlaceHolder_Filter_NameEs_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div> 
                                </div>
                                <hr className="sidebar-divider d-none d-md-block"/>
                                <div className="formdi-pending-action-group">
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditArticle}>
                                    {t('Button_Apply')}
                                  </button> 
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersArticle}>
                                    {t('Button_Cancel_Filters')}
                                  </button>
                                </div>  
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>
                  }  
                  
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                }
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

PurchaseDeliverySearchArticles.propTypes = {
  showModalSearchArticles: PropTypes.bool.isRequired,
  setShowModalSearchArticles: PropTypes.func.isRequired,
  setFormPurchaseDelivery: PropTypes.func.isRequired
};

export default PurchaseDeliverySearchArticles;

